import { changeGate } from '@intercom/pulse/lib/computed-properties';
import BlockRange from './../block-range';
import { and, or, notEmpty } from '@ember/object/computed';
import Em from 'ember';
export default Em.Mixin.create({
  _currentEditableEntityInit: Em.on('init', function () {
    this.get('selectionInfoChanged');
  }),
  isSingleBlockWithEditor: and('isSingleBlock', 'firstSelectedBlock', 'firstSelectedBlock.hasEditor'),
  selectionInfoChanged: changeGate('info'),
  currentEditableObjectChanged: changeGate('currentEditableObject.id'),
  currentEditableObjectOrSelectionChanged: or('currentEditableObjectChanged', 'selectionInfoChanged'),
  selectedEntities: Em.computed('selectionInfoChanged', function () {
    //TODO: tests
    let entities = [];
    if (!this.get('firstSelectedBlock')) {
      return entities;
    }
    if (this.get('isSingleBlock') && !this.get('firstSelectedBlock.isListType')) {
      entities = this.get('firstSelectedBlock.entities').withinRange(BlockRange.atPositionIndex(this.get('startPositionIndex'), this.get('endPositionIndex')));
    }
    if (this.get('isSingleBlock') && this.get('firstSelectedBlock.isListType') && this.get('isSingleItem')) {
      entities = this.get('firstSelectedBlock.blockList').objectAt(this.get('startItemIndex')).get('entities').withinRange(BlockRange.atPositionIndex(this.get('startPositionIndex'), this.get('endPositionIndex')));
    }
    return entities;
  }),
  currentEditableObject: Em.computed('currentEditableEntity', 'currentEditableBlock', function () {
    if (this.get('currentEditableEntity')) {
      return this.get('currentEditableEntity');
    } else {
      return this.get('currentEditableBlock');
    }
  }),
  hasCurrentEditableObject: notEmpty('currentEditableObject'),
  currentEditableEntity: Em.computed('selectedEntities.[]', function () {
    return this.get('currentEditableAttribute') || this.get('currentEditableAnchor');
  }),
  currentEditableAttribute: Em.computed('selectedEntities.[]', function () {
    let entity;
    let selectedEntities = this.get('selectedEntities');
    let selection = this;
    let filteredEntities = selectedEntities.filterBy('type', 'attribute');
    if (!filteredEntities) {
      return false;
    }
    for (let i = 0; i < filteredEntities.get('length'); i++) {
      entity = filteredEntities.objectAt(i);
      if (entity.isSelectedForEdit(selection)) {
        return entity;
      }
    }
  }),
  currentEditableAnchor: Em.computed('selectedEntities.[]', function () {
    let selectedEntities = this.get('selectedEntities');
    let selection = this;
    let filteredEntities = selectedEntities.filterBy('type', 'anchor');
    if (filteredEntities.get('length') === 1) {
      let anchor = filteredEntities.get('firstObject');
      if (anchor.isSelectedForEdit(selection)) {
        return anchor;
      }
    }
  }),
  recalculateCurrentEditableEntity() {
    this.notifyPropertyChange('selectedEntities');
  },
  currentEditableBlock: Em.computed('firstSelectedBlock', 'isSingleBlockWithEditor', function () {
    if (this.get('isSingleBlockWithEditor')) {
      return this.get('firstSelectedBlock');
    }
    return null;
  })
});